import type React from 'react';
import { useAppSelector } from 'redux/hooks';
import { MetaDataSelector } from 'redux/features/jobList';
import { createOptimizedContext } from '@doda/common/src/utils/createOptimizedContext';
import { BasicLayout } from 'components/layouts/BasicLayout';
import { FollowSearchResultsNavigation } from 'components/FollowSearchResultsNavigation';
import { loginStatusSelector } from '@doda/common/src/redux/features/memberInfo';
import { DesiredCondModal } from './DesiredCondModal';
import styles from '../screens/MatchJobListScreen/index.module.scss';
import { HEADER_NAV_MENU } from '../../../../../constants/headerNavMenu';

/** PageLayout Props*/
interface BaseLayoutProps {
  /** children */
  children: React.ReactNode;
}

const [ModalProvider, useModalState, useSetModal] =
  createOptimizedContext(false);

export { useModalState, useSetModal };

const LEAD_SENTENCE = '求人情報の検索結果一覧 - 転職ならdoda（デューダ）';

export const PageLayout = ({ children }: BaseLayoutProps) => {
  return (
    <ModalProvider>
      <BasicLayout
        selectedNavItem={HEADER_NAV_MENU.SEARCH}
        leadSentence={LEAD_SENTENCE}
      >
        <FollowSearch />
        {children}
      </BasicLayout>
      <DesiredCondModal />
    </ModalProvider>
  );
};

const FollowSearch = () => {
  const loginStatus = useAppSelector(loginStatusSelector);
  const jobListMeta = useAppSelector(MetaDataSelector);

  return (
    <FollowSearchResultsNavigation
      loginStatus={loginStatus}
      totalCount={jobListMeta?.totalCount ?? 0}
      resultCount={jobListMeta?.resultCount ?? 0}
      offset={jobListMeta?.offset ?? 0}
    />
  );
};

export const Content = ({ children }: BaseLayoutProps) => {
  return <div className={styles['matchJobList-content']}>{children}</div>;
};

export const SideSection = ({ children }: BaseLayoutProps) => {
  return <aside className={styles['matchJobList-side']}>{children}</aside>;
};

export const MainSection = ({ children }: BaseLayoutProps) => {
  return <section className={styles['matchJobList-main']}>{children}</section>;
};
